(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dreambrew-landing"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const desktopWidth = 1920;
      const desktopHeight = 1080;
      const mobileWidth = 430;
      const mobileHeight = 932;
      const mobileBreakpoint = 767;

      const updateSectionScale = (section) => {
        const isMobile = window.innerWidth <= mobileBreakpoint;
        const designWidth = isMobile ? mobileWidth : desktopWidth;
        const designHeight = isMobile ? mobileHeight : desktopHeight;
        const scale = Math.min(window.innerWidth / designWidth, window.innerHeight / designHeight);

        section.classList.toggle('mobile-layout', isMobile);
        section.style.setProperty('--stage-scale', String(scale));
      };

      const setActiveStep = (section, stepName) => {
        section.querySelectorAll('[data-dreambrew-step]').forEach((step) => {
          step.classList.toggle('is-active', step.dataset.dreambrewStep === stepName);
        });

        section.dataset.dreambrewActiveStep = stepName;
      };

      const showMessage = (section, selector, message) => {
        const node = section.querySelector(selector);
        if (!node) return;
        
        if (message) {
          node.textContent = message;
          node.hidden = false;
        } else {
          node.textContent = '';
          node.hidden = true;
        }
      };

      const submitToKlaviyo = async (section, email, phone = null) => {
        const payload = { email };
        if (phone) {
          payload.phone = phone;
        }

        console.log('Submitting to proxy:', payload);

        const response = await fetch('https://dm-klayvio-proxy.vercel.app/api/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        console.log('Proxy response status:', response.status);

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          console.log('Proxy error response:', errorData);
          throw new Error(errorData.error || 'Subscription failed');
        }

        const result = await response.json();
        console.log('Subscription successful:', result);
        return result;
      };

      const bindKlaviyoFlow = (section) => {
        if (section.dataset.klaviyoFlowBound === 'true') {
          return;
        }

        section.dataset.klaviyoFlowBound = 'true';

        const emailForm = section.querySelector('[data-dreambrew-email-form]');
        const smsForm = section.querySelector('[data-dreambrew-sms-form]');
        const smsInput = section.querySelector('.dreambrew-landing__step--sms .dreambrew-landing__phone-input');

        let capturedEmail = '';

        setActiveStep(section, 'email');

        if (emailForm) {
          emailForm.addEventListener('submit', async (event) => {
            event.preventDefault();

            const formData = new FormData(emailForm);
            const email = formData.get('email');
            const emailConsent = formData.get('email_consent');

            if (!email || !email.includes('@')) {
              showMessage(section, '[data-dreambrew-email-error]', 'Please enter a valid email address.');
              return;
            }

            if (!emailConsent) {
              showMessage(section, '[data-dreambrew-email-error]', 'Please agree to receive marketing emails.');
              return;
            }

            showMessage(section, '[data-dreambrew-email-error]', '');
            emailForm.classList.add('is-submitting');

            try {
              await submitToKlaviyo(section, email);
              capturedEmail = email;
              setActiveStep(section, 'sms');

              if (smsInput) {
                smsInput.focus();
              }
            } catch (error) {
              showMessage(section, '[data-dreambrew-email-error]', error.message || 'Something went wrong. Please try again.');
            } finally {
              emailForm.classList.remove('is-submitting');
            }
          });
        }

        if (smsForm) {
          smsForm.addEventListener('submit', async (event) => {
            event.preventDefault();

            const formData = new FormData(smsForm);
            let phone = formData.get('phone');
            const smsConsent = formData.get('sms_consent');

            if (!phone || phone.length < 7) {
              showMessage(section, '[data-dreambrew-sms-error]', 'Please enter a valid phone number.');
              return;
            }

            if (!smsConsent) {
              showMessage(section, '[data-dreambrew-sms-error]', 'Please agree to receive marketing text messages.');
              return;
            }

            // Format phone to E.164 format for Klaviyo
            phone = phone.replace(/\D/g, ''); // Remove non-digits
            if (!phone.startsWith('1') && phone.length === 10) {
              phone = '1' + phone; // Add US country code if missing
            }
            phone = '+' + phone; // Add + prefix

            console.log('Submitting SMS with email:', capturedEmail, 'phone:', phone);

            showMessage(section, '[data-dreambrew-sms-error]', '');
            smsForm.classList.add('is-submitting');

            try {
              await submitToKlaviyo(section, capturedEmail, phone);
              showMessage(section, '[data-dreambrew-sms-success]', smsForm.querySelector('[data-dreambrew-sms-success]').textContent);
              smsForm.querySelector('.dreambrew-landing__phone-wrapper').style.display = 'none';
              smsForm.querySelector('.dreambrew-landing__consent').style.display = 'none';
            } catch (error) {
              showMessage(section, '[data-dreambrew-sms-error]', error.message || 'Something went wrong. Please try again.');
            } finally {
              smsForm.classList.remove('is-submitting');
            }
          });
        }
      };

      const updateAllDreambrewLandings = () => {
        document.querySelectorAll('.dreambrew-landing').forEach((section) => {
          updateSectionScale(section);
          bindKlaviyoFlow(section);
        });
      };

      if (!window.__dreambrewLandingResizeBound) {
        window.addEventListener('resize', updateAllDreambrewLandings);
        document.addEventListener('shopify:section:load', updateAllDreambrewLandings);
        window.__dreambrewLandingResizeBound = true;
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateAllDreambrewLandings, { once: true });
      } else {
        updateAllDreambrewLandings();
      }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
